/**
 *
 * Checkbox
 *
 */

import React from 'react';
import styled from 'styled-components';
import { Check } from '../Icon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons';

export const CheckIconContainer = styled.div`
  width: 16px;
  height: 16px;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid #b7babc;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 6px;
  font-size: 17px;
  min-width: 16px;
  min-height: 16px;
  cursor: pointer;

  .icon {
    padding: 0;
    > .fa-check {
      border-radius: 4px;
    }
  }
  .check {
    > .fa-check {
      color: white;
      background-color: #0bcf97;
    }
  }

  .round-check {
    width: 85%;
    height: 85%;
    border-radius: 50%;
    background-color: black;
  }

  &.green {
    width: 17px;
    height: 17px;
    font-size: 17px;
    color: #0bcf97;
    background-color: white;
  }

  background-color: ${props => (props.disabled ? 'lightgrey' : '')};
  cursor: ${props => (props.disabled ? 'not-allowed' : '')};
`;

const CheckBoxContainer = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: ${props => (props.smallText ? '10px' : '')};
`;

export function Checkbox(props) {
  const onChange = props.disabled ? () => {} : props.onChange;
  return (
    <CheckBoxContainer className="checkbox" smallText={props.smallText}>
      {!props.className ? (
        <CheckIconContainer disabled={props.disabled} onClick={onChange}>
          {props.checked ? <Check /> : ''}
        </CheckIconContainer>
      ) : (
        <CheckIconContainer disabled={props.disabled} onClick={onChange} className={props.className}>
          {props.checked && !props.rounded && <FontAwesomeIcon icon={faCheckSquare} />}
          {props.checked && props.rounded && <div className="round-check"></div>}
        </CheckIconContainer>
      )}
      {props.children ? <label onClick={onChange}> {props.children} </label> : ''}
      {/*<input type="checkbox" name={props.name ?? ''} checked={props.checked ?? false} readOnly />*/}
    </CheckBoxContainer>
  );
}
